export type AttributeDataType =
  | "text"
  | "number"
  | "boolean"
  | "date"
  | "select";
export type AttributeApplicableTo =
  | "all"
  | "contact_type"
  | "member_account"
  | "member_individual";

export interface AttributeDefinition {
  id: string;
  name: string;
  slug: string;
  description?: string;
  data_type: AttributeDataType;
  is_multi_valued: boolean;
  select_options?: string[];
  applicable_to: AttributeApplicableTo;
  applicable_contact_types?: string[];
  is_active: boolean;
  display_order: number;
  created_by?: string;
  created_at: string;
  updated_at: string;
}

export interface ContactAttributeValue {
  id: string;
  contact_id: string;
  attribute_id: string;
  value_text?: string | null;
  value_number?: number | null;
  value_boolean?: boolean | null;
  value_date?: string | null;
  sort_order: number;
  created_by?: string;
  created_at: string;
  updated_at: string;
  // joined
  attribute?: AttributeDefinition;
}

export interface CreateAttributeDefinitionDTO {
  name: string;
  slug?: string;
  description?: string;
  data_type: AttributeDataType;
  is_multi_valued: boolean;
  select_options?: string[];
  applicable_to: AttributeApplicableTo;
  applicable_contact_types?: string[];
  display_order?: number;
}

export interface UpdateAttributeDefinitionDTO {
  name?: string;
  description?: string;
  data_type?: AttributeDataType;
  is_multi_valued?: boolean;
  select_options?: string[];
  applicable_to?: AttributeApplicableTo;
  applicable_contact_types?: string[];
  is_active?: boolean;
  display_order?: number;
}

export interface AttributeValueInput {
  value_text?: string;
  value_number?: number;
  value_boolean?: boolean;
  value_date?: string;
}

export function getDisplayValue(
  value: ContactAttributeValue,
  def: AttributeDefinition,
): string {
  switch (def.data_type) {
    case "text":
    case "select":
      return value.value_text ?? "";
    case "number":
      return value.value_number !== null && value.value_number !== undefined
        ? String(value.value_number)
        : "";
    case "boolean":
      return value.value_boolean !== null && value.value_boolean !== undefined
        ? value.value_boolean
          ? "Yes"
          : "No"
        : "";
    case "date":
      return value.value_date
        ? new Date(value.value_date).toLocaleDateString()
        : "";
    default:
      return "";
  }
}
